export default {"src":"/_next/static/media/intro.d855d295.svg","height":428,"width":710,"blurWidth":0,"blurHeight":0};